import { useNavigate } from 'react-router-dom';
import { getTournamentOrganizerLabel } from '../../../utils/tournamentPresentation';

const formatDistance = (distanceKm) => {
  if (!Number.isFinite(Number(distanceKm))) return '';
  const rounded = Number(distanceKm) >= 10 ? Math.round(Number(distanceKm)) : Number(distanceKm).toFixed(1);
  return `${rounded} km away`;
};

const formatDate = (value) => {
  if (!value) return 'Date TBD';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return 'Date TBD';
  return parsed.toLocaleDateString();
};

const NearbyTournamentCard = ({ tournament, isOngoing = false }) => {
  const navigate = useNavigate();
  const organizerLabel = getTournamentOrganizerLabel(tournament);

  const openTournament = () => {
    if (tournament?.id) {
      navigate(`/public/tournaments/${tournament.id}/leaderboard`);
    }
  };

  return (
    <article className="card border-0 shadow-sm h-100 nearby-card">
      <div className="card-body d-flex flex-column gap-2">
        <div className="d-flex justify-content-between align-items-start gap-2">
          <h3 className="h6 mb-0">{tournament?.name || 'Tournament'}</h3>
          <span className={`badge ${isOngoing ? 'text-bg-success' : 'text-bg-primary'}`}>{isOngoing ? 'ONGOING' : 'UPCOMING'}</span>
        </div>
        {organizerLabel ? <p className="mb-0 text-muted small text-truncate" title={organizerLabel}>{organizerLabel}</p> : null}
        <p className="mb-0 small">{tournament?.venueName || tournament?.city || 'Venue not set'}</p>
        <p className="mb-0 text-muted small">Starts {formatDate(tournament?.startTime)}</p>

        <div className="d-flex justify-content-between align-items-center mt-auto pt-2">
          <span className="badge text-bg-light nearby-distance">{formatDistance(tournament?.distanceKm)}</span>
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={openTournament}>
            {String(tournament?.cta || '').toLowerCase() === 'register' ? 'Register' : 'View Tournament'}
          </button>
        </div>
      </div>
    </article>
  );
};

export default NearbyTournamentCard;
